import AppResident from '@/components/App/AppResident.vue'

const Resident = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-resident', AppResident)
    Vue.prototype.$resident = {
      add(params) {
        Resident.EventBus.$emit('add', params)
      },
      edit(params) {
        Resident.EventBus.$emit('edit', params)
      }
    }
  }
}

export default Resident